/* MonKoku Maison · Duftsuche: frei beschreiben, was man sucht ("warm, süß, Herbst") */
(function () {
  'use strict';
  var PAGE = 24;
  var STOP = 'fur,fuer,uber,im,in,den,die,der,das,dem,ein,eine,einen,mit,und,oder,es,ich,mir,mich,suche,suchen,mag,mochte,moechte,soll,nach,von,zum,zur,bei,wie,auf,etwas,duft,dufte,parfum,parfume,aber,sehr,ganz,ist,sind,sein,will,gern,gerne,gerade,wenn,am,um,fuers,furs'.split(',');
  /* Wortfelder: was meinen Menschen, wenn sie "warm" oder "frisch" schreiben? */
  var LEX = [
    [/^(warm|gemutlich|kuschel|behaglich|wohlig|cozy|cosy)/, { f: ['orientalisch', 'wuerzig', 'cremig', 'suess'], n: ['vanille', 'amber', 'tonka', 'zimt', 'sandelholz', 'moschus', 'benzoe', 'honig', 'weihrauch'], s: ['herbst', 'winter'] }],
    [/^(frisch|spritzig|leicht|luftig|klar|sauber|erfrisch|kuhl|cool)/, { f: ['frisch', 'aromatisch', 'fruchtig'], n: ['bergamotte', 'zitrone', 'limette', 'grapefruit', 'mandarine', 'minze', 'lavendel', 'meersalz', 'salbei'], s: ['fruhling', 'sommer'] }],
    [/^(suss|suess|zuckrig|naschig|gourmand|bonbon|dessert)/, { f: ['suess', 'cremig', 'fruchtig'], n: ['vanille', 'karamell', 'tonka', 'honig', 'zucker', 'schokolade', 'kirsche', 'mandel', 'kokos', 'praline'] }],
    [/^(wurzig|scharf|pikant|gewurz)/, { f: ['wuerzig'], n: ['pfeffer', 'zimt', 'kardamom', 'safran', 'ingwer', 'nelke', 'muskat'] }],
    [/^(holz|erdig|wald)/, { f: ['holzig'], n: ['zeder', 'sandelholz', 'vetiver', 'patschuli', 'patchouli', 'eiche', 'zypresse', 'guaiak'] }],
    [/^(blum|floral|bluten)/, { f: ['blumig'], n: ['rose', 'jasmin', 'pfingstrose', 'veilchen', 'iris', 'magnolie', 'neroli', 'orangenblute', 'lilie', 'freesie', 'tuberose'] }],
    [/^(frucht|saftig|beeren)/, { f: ['fruchtig'], n: ['apfel', 'birne', 'pfirsich', 'kirsche', 'ananas', 'beere', 'himbeere', 'erdbeere', 'johannisbeere', 'mango', 'melone'] }],
    [/^(leder|ledrig|tabak)/, { f: ['ledrig'], n: ['leder', 'tabak', 'wildleder'] }],
    [/^(cremig|weich|pudrig|samtig)/, { f: ['cremig'], n: ['vanille', 'moschus', 'iris', 'tonka', 'sandelholz'] }],
    [/^(orient|opulent|schwer|intensiv|kraftvoll)/, { f: ['orientalisch'], n: ['amber', 'oud', 'weihrauch', 'myrrhe', 'safran', 'vanille'] }],
    [/^(fruhling|fruhjahr)/, { s: ['fruhling'] }],
    [/^(sommer|sonne|urlaub|strand|hitze)/, { s: ['sommer'], f: ['frisch'] }],
    [/^(herbst|regen)/, { s: ['herbst'] }],
    [/^(winter|kalt|schnee|weihnacht)/, { s: ['winter'], f: ['wuerzig', 'orientalisch'] }],
    [/^(alltag|buro|arbeit|taglich|uni|schule)/, { o: ['alltaglich'] }],
    [/^(abend|date|ausgehen|party|club|nacht|fest|hochzeit|anlass|dinner|romant)/, { o: ['besonderer anlass'], f: ['orientalisch', 'suess'] }]
  ];

  function lexFor(t) {
    for (var i = 0; i < LEX.length; i++) if (LEX[i][0].test(t)) return LEX[i][1];
    return null;
  }
  function lexMax(l) {
    return Math.min((l.f || []).length, 2) * 2 + ((l.n || []).length ? 2.4 : 0) + Math.min((l.s || []).length, 2) * 1.6 + ((l.o || []).length ? 1.6 : 0);
  }

  function init(el) {
    var M = window.MKS;
    if (!M || el.__mksr) return;
    el.__mksr = 1;
    var esc = M.esc;
    var input = el.querySelector('[data-q]'), form = el.querySelector('[data-form]'), tools = el.querySelector('[data-tools]');
    var grid = el.querySelector('[data-grid]'), count = el.querySelector('[data-count]'), more = el.querySelector('[data-more]');
    var items = [], g = '', q = '', shown = PAGE, last = [], timer = 0;

    function ok(x) { return x && x.v5 && x.v5[2] === 1; }
    function prep(x) {
      if (x.nq) return x;
      x.tq = M.norm(x.t);
      x.noq = M.norm(x.n.join(' '));
      x.kq = M.norm(x.k);
      x.fq = M.norm(x.f.map(function (f) { return M.FAM[f] || f; }).join(' '));
      x.rq = M.norm((x.r || []).join(' '));
      x.nq = M.norm([x.n.join(' '), x.k].join(' '));
      x.sq = M.norm((x.s || []).join(' '));
      x.oq = M.norm((x.o || []).join(' '));
      x.sn = Math.max(1, (x.s || []).length);
      x.on = Math.max(1, (x.o || []).length);
      return x;
    }

    function parse(s) {
      var seen = {}, out = [];
      M.norm(s).replace(/[^a-z0-9\s,&+\/\-]/g, ' ').split(/[\s,&+\/]+/).forEach(function (t) {
        t = t.replace(/^-+|-+$/g, '');
        if (t.length < 3 || STOP.indexOf(t) > -1 || seen[t]) return;
        seen[t] = 1; out.push(t);
      });
      /* Originalschreibweise für die Anzeige */
      var orig = {};
      String(s).split(/[\s,&+\/]+/).forEach(function (w) { var k = M.norm(w).replace(/[^a-z0-9\-]/g, ''); if (k && !orig[k]) orig[k] = w.replace(/^[^\wÄÖÜäöüß]+|[^\wÄÖÜäöüß]+$/g, ''); });
      return out.map(function (t) { return { t: t, show: orig[t] || t, lex: lexFor(t) }; });
    }
    function termScore(x, tm) {
      var t = tm.t, l = tm.lex, s = 0;
      /* direkte Treffer: Name, Noten und Duftwelt zählen voll, die breiten Duftrichtungs-Chips nur halb */
      if (x.tq.indexOf(t) > -1 || x.noq.indexOf(t) > -1 || x.fq.indexOf(t) > -1) s = 1;
      else if (x.kq.indexOf(t) > -1) s = 0.8;
      else if (x.rq.indexOf(t) > -1) s = 0.45;
      if (l) {
        var v = 0, nh = 0;
        (l.f || []).forEach(function (f) { if (x.f.indexOf(f) > -1) v += 2; });
        (l.n || []).forEach(function (n) { if (x.nq.indexOf(n) > -1) nh++; });
        v += Math.min(nh, 3) * 0.8;
        /* Jahreszeit und Anlass zählen nur, wenn sie den Duft wirklich unterscheiden (fast alle Düfte tragen mehrere) */
        (l.s || []).forEach(function (a) { if (x.sq.indexOf(a) > -1) v += 1.6 / x.sn; });
        (l.o || []).forEach(function (a) { if (x.oq.indexOf(a) > -1) v += 1.6 * (x.on <= 1 ? 1 : x.on === 2 ? 0.6 : 0.3); });
        var m = lexMax(l);
        if (m) s = Math.max(s, Math.min(1, v / m));
      }
      return s;
    }
    function genderOk(x) {
      if (g === 'd' && x.g === 'h') return false;
      if (g === 'h' && x.g === 'd') return false;
      if (g === 'u' && x.g !== 'u') return false;
      return true;
    }

    function search() {
      var terms = parse(q), pool = items.filter(genderOk);
      if (!terms.length) {
        return { terms: terms, list: pool.filter(function (x) { return x.best && ok(x); }).concat(pool.filter(function (x) { return !x.best && ok(x); })).map(function (x) { return { x: x, hit: [], full: true }; }) };
      }
      var list = [];
      pool.forEach(function (x) {
        var hit = [], tot = 0;
        terms.forEach(function (tm) { var s = termScore(x, tm); tot += s; if (s >= 0.3) hit.push(tm.show); });
        if (hit.length) list.push({ x: x, hit: hit, tot: tot, full: hit.length === terms.length });
      });
      list.sort(function (a, b) {
        if (a.hit.length !== b.hit.length) return b.hit.length - a.hit.length;
        if (Math.abs(a.tot - b.tot) > 0.01) return b.tot - a.tot;
        var oa = ok(a.x) ? 0 : 1, ob = ok(b.x) ? 0 : 1;
        if (oa !== ob) return oa - ob;
        if (a.x.best !== b.x.best) return a.x.best ? -1 : 1;
        return a.x.t.localeCompare(b.x.t, 'de');
      });
      var full = list.filter(function (r) { return r.full; }), nFull = full.length;
      /* genug volle Treffer: nur diese. Sonst die besten Teiltreffer dazu. */
      if (nFull < 6 && terms.length > 1) {
        var floor = Math.max(1, terms.length - 1);
        list = full.concat(list.filter(function (r) { return !r.full && r.hit.length >= floor; }));
      } else list = full;
      return { terms: terms, list: list, full: nFull };
    }

    function card(r, i, nTerms) {
      var x = r.x, av = ok(x), fam = x.f.slice(0, 3).map(function (f) { return M.FAM[f] || f; }).join(' · ');
      var why = r.hit.length ? '<ul class="mksr-why">' + r.hit.map(function (h) { return '<li>' + esc(h) + '</li>'; }).join('') + '</ul>' : '';
      var part = nTerms > 1 && r.hit.length && !r.full ? '<p class="mksr-part">Passt zu ' + r.hit.length + ' von ' + nTerms + ' Begriffen</p>' : '';
      return '<article class="mks-card' + (av ? '' : ' is-out') + '">' +
        '<a class="mks-card__pick" href="' + esc(x.url) + '" aria-label="' + esc(x.t) + ' ansehen"><span class="mks-card__img">' + (x.img ? '<img src="' + esc(x.img) + '" alt="' + esc(x.t) + ' Extrait de Parfum" width="480" height="480" loading="' + (i < 6 ? 'eager' : 'lazy') + '" decoding="async">' : '') + '</span></a>' +
        '<div class="mks-card__body"><h3 class="mks-card__t"><a href="' + esc(x.url) + '">' + esc(x.t) + '</a></h3>' +
        (x.k ? '<p class="mks-card__k">' + esc(x.k) + '</p>' : '') + (fam ? '<p class="mks-card__f">' + esc(fam) + '</p>' : '') + why + part + '</div>' +
        '<div class="mksr-act"><button type="button" class="mksr-probe" data-add="' + esc(x.h) + '"' + (av ? '' : ' disabled') + '>' + (av ? 'Probe · ' + M.money(x.v5[1]) : 'Ausverkauft') + '</button>' +
        '<button type="button" class="mkc-btn" data-mk-cmp="' + esc(x.h) + '" aria-pressed="false"><span class="mkc-btn__i" aria-hidden="true"></span><span data-l>Vergleichen</span></button></div></article>';
    }

    function render() {
      var res = search(), list = res.list, n = res.terms.length;
      last = list;
      var shownList = list.slice(0, shown);
      grid.setAttribute('aria-busy', 'false');
      grid.innerHTML = shownList.length ? shownList.map(function (r, i) { return card(r, i, n); }).join('') : '<div class="mks-empty"><p>Dazu finden wir gerade keinen passenden Duft.</p><p>Versuche es mit anderen Worten, etwa „frisch“, „Vanille“ oder „Abend“, oder lass dir im Duft-Finder helfen.</p><a class="mks-link" href="' + M.root + 'pages/duft-finder">Zum Duft-Finder</a></div>';
      var qs = res.terms.map(function (t) { return t.show; }).join(', ');
      if (!n) count.textContent = 'Unsere Bestseller – oder beschreibe oben, wonach dir ist.';
      else if (!list.length) count.textContent = '';
      else if (n > 1 && !res.full) count.textContent = 'Kein Duft passt zu allem. Das sind die nächstbesten für „' + qs + '“.';
      else if (n > 1 && res.full < list.length) count.textContent = res.full + (res.full === 1 ? ' Duft passt' : ' Düfte passen') + ' zu „' + qs + '“, dazu einige, die zu einem Teil passen.';
      else count.textContent = list.length === 1 ? '1 Duft passt zu „' + qs + '“.' : list.length + ' Düfte passen zu „' + qs + '“.';
      var rest = list.length - shownList.length;
      more.hidden = rest <= 0;
      if (rest > 0) more.querySelector('button').textContent = 'Mehr Düfte zeigen (' + rest + ')';
      if (window.MKC && window.MKC.sync) window.MKC.sync();
    }

    function setUrl() {
      try {
        var u = location.pathname + (q.trim() ? '?q=' + encodeURIComponent(q.trim()) : '') + location.hash;
        history.replaceState(null, '', u);
      } catch (e) { /* egal */ }
    }
    function run() { shown = PAGE; setUrl(); render(); }

    function renderTools() {
      function chip(l, on, v) { return '<button type="button" class="mks-chip' + (on ? ' is-on' : '') + '" data-g="' + v + '" aria-pressed="' + (on ? 'true' : 'false') + '">' + l + '</button>'; }
      tools.innerHTML = '<div class="mks-chips" role="group" aria-label="Für wen">' + chip('Alle', !g, '') + chip('Für Damen', g === 'd', 'd') + chip('Für Herren', g === 'h', 'h') + chip('Unisex', g === 'u', 'u') + '</div>';
    }

    el.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-ex-q],[data-g],[data-more-btn],[data-add],[data-retry]') : null;
      if (!t) return;
      if (t.hasAttribute('data-ex-q')) { q = t.getAttribute('data-ex-q'); input.value = q; run(); }
      else if (t.hasAttribute('data-g')) { g = t.getAttribute('data-g'); renderTools(); run(); }
      else if (t.hasAttribute('data-more-btn')) { shown += PAGE; render(); }
      else if (t.hasAttribute('data-retry')) start();
      else if (t.hasAttribute('data-add')) {
        var x = items.filter(function (i) { return i.h === t.getAttribute('data-add'); })[0];
        if (!x || !ok(x) || t.disabled) return;
        var old = t.textContent; t.disabled = true; t.textContent = 'Einen Moment …';
        M.addToCart([{ id: x.v5[0], quantity: 1 }], '').then(function () { t.textContent = 'Im Warenkorb'; setTimeout(function () { t.textContent = old; t.disabled = false; }, 2200); }).catch(function (er) {
          t.textContent = old; t.disabled = false;
          count.textContent = 'Das hat nicht geklappt: ' + (er && er.message ? er.message : 'Bitte versuche es erneut.');
        });
      }
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); q = input.value; run(); input.blur(); });
    input.addEventListener('input', function () { q = input.value; clearTimeout(timer); timer = setTimeout(run, 200); });

    function start() {
      grid.setAttribute('aria-busy', 'true');
      grid.innerHTML = '<div class="mks-skel" aria-hidden="true"><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i></div>';
      M.load().then(function (all) {
        items = all.map(prep);
        var m = /[?&]q=([^&#]*)/.exec(location.search);
        if (m) { try { q = decodeURIComponent(m[1].replace(/\+/g, ' ')); } catch (e) { q = ''; } input.value = q; }
        renderTools(); render();
      }).catch(function () {
        grid.setAttribute('aria-busy', 'false');
        grid.innerHTML = '<div class="mks-empty"><p>Unsere Düfte konnten gerade nicht geladen werden.</p><button type="button" class="mks-chip is-on" data-retry>Erneut versuchen</button> <a class="mks-link" href="' + M.root + 'collections/all">Zum Sortiment</a></div>';
      });
    }
    start();
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-mksr]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();